<template>
  <echarts :options="options" class="chart-stage"></echarts>
</template>
<script>
import echarts from "./basic";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

// 异型柱状图
// import echarts from "./basicVariant";

export default {
  components: {
    echarts
  },
  props: {
    category: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    grid: {
      type: Object,
      default() {
        return {}
      }
    },
    unit: {
      type: String,
      default: ''
    },
    unitX: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // barColor: ['#ff7c79', '#f19149', '#22ac38','#00a0e9', "#9b66e6", "#ffd451"],
      barColor: [],
      dataColor:[
        // 发电量
        {
          name:this.$t("device.generated"),
          color:'rgb(255, 127, 80)'
        },
        // 买电量
        {
          name:this.$t("device.bought"),
          color:'rgb(251, 255, 46)'
        },
        // 卖电量
        {
          name:this.$t("device.sold"),
          color:'rgb(78, 255, 63)'
        },
        // 充电量
        {
          name:this.$t("device.charged"),
          color:'rgb(46, 255, 205)'
        },
        // 放电量
        {
          name:this.$t("device.discharged"),
          color:'rgb(66, 187, 225)'
        },
        // 用电量
        {
          name:this.$t("device.used"),
          color:'rgb(216, 24, 59)'
        }
      ]
    }
  },
  created() {
    var array = []
    this.data.forEach(element => {
      this.dataColor.forEach(elementItem => {
        if(element.name==elementItem.name){
          array.push(elementItem.color)
        }
      });
    });
    this.barColor = array
  },
  computed: {
    options() {
      console.log(this.category);
      // console.log("this.data柱形",this.data)
      // console.log("this.category",this.category)
      let series = [], legends = []
      this.data.forEach(ele => {
        legends.push(ele.name)
        series.push({
          type: 'bar',
          name: ele.name,
          data: ele.value,

          // [echarts 象形图 pictorialBar（异型柱状图）]
          // type: 'pictorialBar', //设置类型为象形柱状图
          // symbol: 'rect', //图形类型，带圆角的矩形
          // symbolRepeat: true, //图形是否重复
          // symbolMargin: '3', //图形垂直间隔
          // itemStyle: {
          //   color: {
          //     type: 'linear',
          //     x: 0.0,
          //     y: 0.0,
          //     r: 1,
          //     colorStops: [
          //       {
          //         offset: 0,
          //         color: 'rgb(251, 118, 123)'
          //       },
          //       {
          //         offset: 1,
          //         color: 'rgb(204, 46, 72)'
          //       }
          //     ]
          //   }
          // },

        })
      })
      let grid = {
        ...{
          top: "45",
          left: "60",
          right: "30",
          // ===
          bottom: "70"
        }, ...this.grid
      }
      return {
        color: this.barColor,
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          borderColor: "#eee",
          borderWidth: "1",
          textStyle: {
            color: '#666',
            fontSize: 12
          },
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          // ===
          bottom: '15',
          data: this.legend,
          textStyle: {
            color: 'rgba(255, 255, 255, 1)'
          }
        },
        grid: {
          // borderColor: 'red'
        },
        xAxis: [
          {
            type: "category",
            name: this.unitX,
            data: this.category,
            axisLine: {
              lineStyle: {
                color: 'rgba(123, 131, 149, 1)',
                type: 'dashed',
              }
            },
            axisLabel: {
              color: 'rgba(235, 235, 235, 1)',
            },
            axisTick: {
              alignWithLabel: true
            },
            // splitLine: {
            //   lineStyle: {
            //     type: 'dashed',
            //     color: 'rgba(123, 131, 149, 1)'
            //   }
            // }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: this.unit,
            axisLine: {
              lineStyle: {
                color: 'rgba(123, 131, 149, 1)',
                type: 'dashed',
              }
            },
            axisLabel: {
              color: 'rgba(235, 235, 235, 1)',
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(123, 131, 149, 1)'
              }
            }
          }
        ],
        series
      }
    }
  },
};
</script>
<style lang="less" scoped>
.chart-stage {
  height: 100%;
}
</style>


